export default __webpack_public_path__ + "static/media/preact.a7137e57.svg";